import { getAttrMarkup,getBoundToExpr, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator,updateTemplateAttrs } from '@wm/core';
import {Attribute} from "@angular/compiler";

const carouselTagName = 'div';
const dataSetKey = 'dataset';
const idGen = new IDGenerator('wm_carousel_ref_');
const isDynamicCarousel = (node:any) => node.attrs.find((attr:any) => attr.name === 'type' && attr.value === 'dynamic');
// const ɵ0 = isDynamicCarousel;
register('wm-carousel', (): IBuildTaskDef => {
    return {
        pre: (attrs:any,shared:any) => {
          const counter = idGen.nextUid();
          shared.set('carousel_ref', counter);
          return `
                  <${carouselTagName} class="app-carousel carousel"  wmCarousel #${counter}="wmCarousel" wm-droppable=true ${getAttrMarkup(attrs)} interval="0" [ngClass]="${counter}.navigationClass"> `;

        },
        post: () => `</${carouselTagName}>`,
      template :(node:any)=>{
        if (isDynamicCarousel(node)) {
          const datasetAttr = node.attrs.find((attr:any) => attr.name === dataSetKey);
          const widgetNameAttr:Attribute|any = node.attrs.find((attr:any) => attr.name === 'name');
          if (!datasetAttr) {
            return;
          }
          const boundExpr = getBoundToExpr(datasetAttr.value);
          if (!boundExpr) {
            return;
          }
          updateTemplateAttrs(node, boundExpr, widgetNameAttr.value);
        }
      },
      provide: (attrs:any, shared:any) => {
        const provider = new Map();
        provider.set('carousel_ref', shared.get('carousel_ref'));
        return provider;
      }
    };
});

export default () => {};

